import './App.css';
import { BrowserRouter as Router, Routes, Route, Link, Outlet, useNavigate, } from 'react-router-dom';
import ManagerCalendar from './components/ManagerCalendar';
import SignInHomeScreen from './components/SignInHome';
import EmployeeOptionsScreen from './components/EmployeeOptionsScreen';
import VisitorOptionsScreen from './components/VisitorOptionsScreen';
import SignInOutForm from './components/SignInOutForm';
import {getAppLocation} from './utils/storage';
import { HomeScreen } from './components/Home';
import ManagerView from './components/ManagerView';
import { MsalProvider,useMsal, useIsAuthenticated, MsalAuthenticationTemplate } from "@azure/msal-react";
import { IPublicClientApplication, NavigationClient, InteractionStatus, InteractionType} from "@azure/msal-browser";
import { loginRequest } from "./utils/authConfig";
import { CustomNavigationClient } from "./utils/CustomNavigation";

type AppProps = {
  pca: IPublicClientApplication;
};

function errorComponent({error}:any) {
  return <p>An error occured: {error}</p>
}

function LoadingComponent() {
  return <p>Authentication in progress...</p>
}

function App({ pca }: AppProps) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);
  return (
      <MsalProvider instance={pca}>
        <MsalAuthenticationTemplate 
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
        errorComponent={errorComponent} 
        loadingComponent={LoadingComponent}>
        <Pages />
        </MsalAuthenticationTemplate>
      </MsalProvider>
  );
}

function Pages() {
  let location = getAppLocation();

  const EmployeeRoutes = ({ location }: { location: string }) => (
    <Routes>
      <Route index element={<EmployeeOptionsScreen />} />
      <Route
        path="visiting-office-sign-out"
        element={<SignInOutForm formType="employee-sign-out" currentLocation={location} />}
      />
      <Route
        path="main-office-sign-out"
        element={<SignInOutForm formType="main-office-sign-out" currentLocation={location} />}
      />
      <Route
        path="visiting-office-sign-in"
        element={<SignInOutForm formType="visiting-office-sign-in" currentLocation={location} />}
      />
    </Routes>
  );

  const VisitorRoutes = ({ location }: { location: string }) => (
    <Routes>
      <Route index element={<VisitorOptionsScreen />} />
      <Route
        path="visitor-sign-in"
        element={<SignInOutForm formType="visitor-sign-in" currentLocation={location} />}
      />
      <Route
        path="visitor-sign-out"
        element={<SignInOutForm formType="visitor-sign-out" currentLocation={location} />}
      />
    </Routes>
  );

  return (
  <Routes>
    <Route path="/" element={<HomeScreen />} />
    <Route path="/calendar" element={<ManagerCalendar />} />
    
      
    <Route path="/signout" element={<SignInHomeScreen />} />
    <Route path='/manager-view' element={<ManagerView />} />
    <Route path="/signout/employee-options/*" element={<EmployeeRoutes location={location} />} />
    <Route path="/signout/visitor-options/*" element={<VisitorRoutes location={location} />} />
  </Routes>
  );
}

export default App;
